import httpHelper from "@/helpers/httpHelper";
// action types 
export const UPDATE_USER_CARD = "updateUserCard";

// mutation types
// export const SET_UNDONE_REFUND_DETAILS = "setUndoneRefundDetails";


export default {
    state: {
        // updateUserCard: {},
    },
    getters: {
        /**
         * Get list of detailsSharing for current page
         * @param state
         * @returns {*}
         */
        // loadedDetailsUndoneRefund(state) {
        //     return state.detailsUndoneRefund;
        // },
    },
    actions: {
        /**
         * Set the payRefund Status 
         * @param state
         * @param payload
         */
        [UPDATE_USER_CARD](context, payload) {
            return new Promise((resolve, reject) => {
                httpHelper
                    .postData(payload.api, { "nickname": payload.nickname, "account_number": payload.account_number })
                    .then((response) => {

                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error)
                    })
                    .finally(() => { });
            });
        },
        
    },
    mutations: {

        
    }
};